import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { Modal, useModalStyles } from '../common/Modal';
import { createSecondaryItem, createGhostItem } from '../common/modalItems';

const ConfirmModal = ({
  modalRef,
  title,
  message,
  onConfirm,
  confirmText,
  cancelText,
  isLoading = false,
  dialogProps,
}) => {
  const { t } = useTranslation();
  const classes = useModalStyles();

  const actions = [
    createGhostItem({
      onClick: () => modalRef.current.toggleDialog(),
      children: cancelText || t('cancel'),
    }),
    createSecondaryItem({
      onClick: onConfirm,
      disabled: isLoading,
      children: confirmText || t('Yes'),
    }),
  ];

  return (
    <Modal
      modalRef={modalRef}
      title={title}
      actions={actions}
      dialogProps={dialogProps}
    >
      <Typography className={classes.modalText}>
        {message}
      </Typography>
    </Modal>
  );
};

export default ConfirmModal;